module.exports = __webpack_public_path__ + "img/test.cb158b0f.svg";